"use client";

import { FC, Suspense, useMemo } from "react";
import { useSearchParams } from "next/navigation";

import { IImageProps } from "apps/website/components/base/Image/Image";
import { Theme } from "apps/website/maps/Theme.map";

import SectionPreCancellation from "./SectionPreCancellation";

export type TPrecancellationSubscriptionState = "TRIAL" | "DEFAULT";

export interface ISectionPreCancellationSplash {
  theme?: Theme;
  image: IImageProps;
  subscriptionState?: TPrecancellationSubscriptionState;
}

const SuspendedSectionPreCancellationSplash: FC<ISectionPreCancellationSplash> = ({ theme, image, subscriptionState = "DEFAULT" }: ISectionPreCancellationSplash) => {
  const query = useSearchParams();

  const catName = useMemo(() => {
    if (query?.get("catName")) {
      return query.get("catName");
    }
    return "Your cat";
  }, [ query ]);

  return (
    <SectionPreCancellation
      theme={theme}
      image={image}
      catName={catName ?? ""}
      subscriptionState={subscriptionState}
    />
  );
};

export const SectionPreCancellationSplash: FC<ISectionPreCancellationSplash> = ({
  theme, image, subscriptionState,
}) => (
  <Suspense>
    <SuspendedSectionPreCancellationSplash theme={theme} image={image} subscriptionState={subscriptionState} />
  </Suspense>
);

export default SectionPreCancellationSplash;
